import { css } from "styled-components";

// The one focus ring. _buttons.scss gives it to anything carrying .btn, but a
// styled.button does not, so every component built here needs it explicitly or it has no
// visible focus at all — invisible to a keyboard, and an accessibility failure rather than
// a cosmetic one.
//
// :focus-visible rather than :focus, so a pointer click does not leave a ring behind.
export const focusRing = css`
    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: 2px solid var(--pw-focus-ring);
        outline-offset: 2px;
    }
`;

export default focusRing;
